module.exports = __webpack_public_path__ + "img/39.5193ad6b.png";